import { addBlank } from "../default-constants";

/**　ラベル */
export const LABELS = {
  TABLE: {
    TITLE: "ユーザ",
    DEACTIVATED_REASON: "無効化理由",
  },
  COMMON: {
    TYPE: "ユーザ種別",
    COMPANY_NAME: "事業者名",
    HOLDINGS_NAME: "ホールディングス名",
    GW_COMPANY_NAME: "ＧＷ事業者名",
    EMAIL: "メールアドレス",
    DISPLAY_NAME: "氏名",
    STATUS: "状態",
    AUTHED_AT: "最終ログイン日時",
    MEMO: "備考",
    COMMENT: "内部コメント",
    PERMISSION: "権限",
    SEARCH_COMPANY_NAME: "事業者名・カナ",
    SEARCH_HOLDINGS_NAME: "ホールディングス名・カナ",
    SEARCH_GW_COMPANY_NAME: "ＧＷ事業者名・カナ",
    USER_NAME_CONSTRAINT_TEXT:
      "フルネームで検索する場合は姓と名の間に半角スペースを入れてください",
  },
} as const;

/**　定数 */
export const DISPLAY_NAME = "name";
export const EMAIL = "email";
export const TYPE = "type";
export const COMPANY_NAME = "companyName";
export const STATUS = "status";
export const DEACTIVATED_REASON = "deactivatedReason";
export const AUTHED_AT = "authedAt";
export const MEMO = "memo";
export const COMMENT = "comment";

export const statusData = addBlank([
  {
    value: "false",
    label: "有効",
  },
  {
    value: "true",
    label: "無効",
  },
]);

export const getCompanyTypeLabel = (companyType: string) => {
  if (["02", "03"].includes(companyType)) {
    return LABELS.COMMON.SEARCH_COMPANY_NAME;
  } else if (["04"].includes(companyType)) {
    return LABELS.COMMON.SEARCH_HOLDINGS_NAME;
  } else if (["05"].includes(companyType)) {
    return LABELS.COMMON.SEARCH_GW_COMPANY_NAME;
  } else {
    return "";
  }
};
